export default __webpack_public_path__ + "static/media/my-bg1.2e7d525f.jpg";